export enum QueryKeys {
  TerminalCredentials = 'terminalCredentials',
  MissingCredentialsCount = 'missingCredentialsCount',
  PortalListing = 'portalListing',
}
